import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message, Avatar, Typography, Space, Divider } from 'antd';
import { UserOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import '../styles/global-input-fixes.css';

const { Title, Text } = Typography;

const Profile = () => {
  const { user, updateProfile } = useAuth();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        name: user.name,
        email: user.email,
        codigo: user.codigo
      });
    }
  }, [user, form]);

  const handleSave = async (values) => {
    setLoading(true);
    try {
      const result = await updateProfile(values);
      if (result.success) {
        message.success('Perfil atualizado com sucesso!');
        setEditing(false);
      } else {
        message.error(result.error || 'Erro ao atualizar perfil');
      }
    } catch (error) {
      message.error('Erro ao atualizar perfil');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.setFieldsValue({
      name: user.name,
      email: user.email,
      codigo: user.codigo
    });
    setEditing(false);
  };

  return (
    <Layout>
      <div style={{
        padding: '24px',
        background: '#f5f5f5',
        minHeight: 'calc(100vh - 64px)'
      }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <Title level={2} style={{ marginBottom: '24px', color: '#1a1a1a' }}>
            Meu Perfil
          </Title>

          <Card
            style={{
              borderRadius: '12px',
              border: 'none',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
            }}
          >
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <Avatar
                size={80}
                icon={<UserOutlined />}
                style={{
                  backgroundColor: '#1890ff',
                  marginBottom: '16px'
                }}
              />
              <Title level={4} style={{ margin: 0 }}>
                {user?.name}
              </Title>
              <Text type="secondary">
                {user?.email}
              </Text>
            </div>

            <Divider />

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSave}
              disabled={!editing}
            >
              <Form.Item
                label="Nome"
                name="name"
                rules={[
                  { required: true, message: 'Por favor, insira seu nome!' },
                  { min: 2, message: 'Nome deve ter pelo menos 2 caracteres!' }
                ]}
              >
                <Input
                  placeholder="Seu nome completo"
                  disabled={!editing}
                />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: 'Por favor, insira seu email!' },
                  { type: 'email', message: 'Por favor, insira um email válido!' }
                ]}
              >
                <Input
                  placeholder="seu.email@exemplo.com"
                  disabled={!editing}
                />
              </Form.Item>

              <Form.Item
                label="Código do Funcionário"
                name="codigo"
              >
                <Input
                  placeholder="Código do funcionário"
                  disabled={true}
                />
              </Form.Item>

              <div style={{ marginTop: '24px' }}>
                {!editing ? (
                  <Button
                    type="primary"
                    icon={<EditOutlined />}
                    onClick={() => setEditing(true)}
                    size="large"
                    block
                  >
                    Editar Perfil
                  </Button>
                ) : (
                  <Space style={{ width: '100%' }} direction="vertical">
                    <Button
                      type="primary"
                      icon={<SaveOutlined />}
                      htmlType="submit"
                      loading={loading}
                      size="large"
                      block
                    >
                      Salvar Alterações
                    </Button>
                    <Button
                      onClick={handleCancel}
                      size="large"
                      block
                    >
                      Cancelar
                    </Button>
                  </Space>
                )}
              </div>
            </Form>

            <Divider />

            <div>
              <Title level={5} style={{ marginBottom: '16px' }}>
                Informações da Organização
              </Title>
              <Space direction="vertical" style={{ width: '100%' }}>
                <div>
                  <Text strong>Organização: </Text>
                  <Text>{user?.organization?.name || 'N/A'}</Text>
                </div>
                <div>
                  <Text strong>Filial: </Text>
                  <Text>{user?.assignedBranch?.name || 'N/A'}</Text>
                </div>
                <div>
                  <Text strong>Roles: </Text>
                  <Text>
                    {user?.roles?.map(ur => ur.role.name).join(', ') || 'N/A'}
                  </Text>
                </div>
              </Space>
            </div>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;